function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M253.476,358.88c-24.24,0-43.96,19.656-43.96,43.804c0,24.156,19.72,43.82,43.96,43.82 c24.248,0,43.968-19.664,43.968-43.82C297.444,378.536,277.72,358.88,253.476,358.88z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M360.732,299.197c-28.62-28.604-66.716-44.364-107.256-44.364c-40.384,0-78.376,15.656-106.988,44.08 c-11.556,11.5-11.576,30.236-0.048,41.756c5.6,5.608,13.056,8.688,20.992,8.688c7.9,0,15.328-3.064,20.92-8.624 c17.412-17.304,40.54-26.836,65.124-26.836c24.676,0,47.868,9.592,65.292,27c5.6,5.592,13.052,8.68,20.98,8.68 c7.908,0,15.332-3.064,20.928-8.624C372.248,329.452,372.268,310.725,360.732,299.197z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M498.512,161.872C433.08,96.601,346.052,60.665,253.476,60.665c-92.452,0-179.392,35.852-244.804,100.968 c-11.556,11.5-11.564,30.236-0.016,41.756c5.596,5.58,13.04,8.648,20.96,8.648c7.916,0,15.352-3.056,20.948-8.632 c54.22-53.968,126.28-83.696,202.912-83.696c76.744,0,148.876,29.788,203.108,83.9c5.596,5.584,13.052,8.664,20.968,8.664 c7.912,0,15.348-3.072,20.94-8.64C510.052,192.124,510.064,173.381,498.512,161.872z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M427.876,232.256C381.3,185.788,319.364,160.2,253.476,160.2c-65.768,0-127.612,25.508-174.148,71.812 c-5.604,5.572-8.688,12.984-8.7,20.876c0,7.884,3.072,15.304,8.668,20.884c5.596,5.584,13.044,8.664,20.964,8.664 c7.908,0,15.344-3.072,20.948-8.632c35.352-35.172,82.328-54.548,132.268-54.548c50.044,0,97.084,19.444,132.46,54.736 c5.604,5.592,13.048,8.672,20.972,8.672c7.912,0,15.352-3.072,20.94-8.64c5.596-5.572,8.688-12.984,8.692-20.876 C436.548,245.256,433.468,237.844,427.876,232.256z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var SvgConnected = function SvgConnected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 507.169 507.169",
    style: {
      enableBackground: "new 0 0 507.169 507.169"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConnected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/connected.ad587cef.svg";
export { ForwardRef as ReactComponent };